import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import InvitationDTO from '../../models/invitation';
import baseQueryWithReauth from './base';

export interface ScannerKeyDTO {
  id: string;
  key: string;
  user_id: string;
  is_active: boolean;
  expires_at: string;
  business_id: string;
  created_at: string;
  updated_at: string;
}

export interface UseScannerKeyDTO {
  key: string;
  user_id: string;
}

interface UseScannerKeyResponse {
  invitation: InvitationDTO;
}

export interface CreateScannerKeyDTO {
  businessId: string;
}

const scannerKeysApi = createApi({
  reducerPath: 'scannerKeysApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['scanner-keys'],
  endpoints: (build) => ({
    useScannerKey: build.mutation<UseScannerKeyResponse, UseScannerKeyDTO>({
      query: (data) => ({
        url: '/scanner-keys/use',
        method: 'POST',
        body: data,
      }),
      transformResponse: (response: Response<UseScannerKeyResponse>) => response.data || { invitation: {} as InvitationDTO },
    }),
    createScannerKey: build.mutation<Response<ScannerKeyDTO>, CreateScannerKeyDTO>({
      query: ({ businessId }) => ({
        url: `businesses/${businessId}/scanner-keys/`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useUseScannerKeyMutation,
  useCreateScannerKeyMutation,
} = scannerKeysApi;

export { scannerKeysApi };
